// ── API de traductions ────────────────────────────────────────────────────────

/**
 * Appelle /traductions/lexies pour une paire de langues.
 * Utilise fetch() natif (supporté dès iOS 12 / Chrome 61 / Firefox 60).
 *
 * @param {string} searchText  mot à traduire
 * @param {string} langSrc     code de langue source ("en", "fr", "es"…)
 * @param {string} [langDst]   code de langue cible optionnel ; si absent ou égal à langSrc,
 *                             l'API retourne les champs de la langue source (comportement historique).
 *                             Utile pour la traduction bidirectionnelle : langSrc="fr", langDst="en".
 * @returns {Promise<Object>}  objet JSON retourné par l'API ({ données: [...] })
 */
export function getTraductionsResults(searchText, langSrc, langDst) {
    let uri = window.location.origin + '/v2/traductions/lexies?mot='
        + encodeURIComponent(searchText)
        + '&lang=' + encodeURIComponent(langSrc);
    if (langDst && langDst !== langSrc)
        uri += '&retour=' + encodeURIComponent(langDst);
    return fetch(uri).then(function(réponse) {
        if (!réponse.ok) throw new Error('HTTP ' + réponse.status);
        return réponse.json();
    });
}
